export default __webpack_public_path__ + "static/media/caera-mockup-app.5421c3f7.png";